import React from 'react';

import './style.scss';

const PropertiesTable = ({ children }) => {
  return (
    <div className="Properties">
      { children }
    </div>
  );
};

PropertiesTable.Property = ({ label, value, suffix }) => {
  return (
    <div className="Properties__property">
      <div className="Properties__property__label">{ label }</div>
      <div className="Properties__property__value">{ value } {suffix ? <span className="Properties__property__value-suffix">{suffix}</span> : null}</div>
    </div>
  );
};

export default PropertiesTable;
